var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessToast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58565",
    "data-name": "Group 58565",
    transform: "translate(20428 15590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7791",
    "data-name": "Rectangle 7791",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(-20428 -15590)",
    fill: "#3ebe63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M23.7,12.129A11.567,11.567,0,1,1,12.129.562,11.567,11.567,0,0,1,23.7,12.129Zm-12.9,6.125,8.582-8.582a.746.746,0,0,0,0-1.055L18.318,7.561a.746.746,0,0,0-1.055,0l-7,7L7,11.293a.746.746,0,0,0-1.055,0L4.885,12.348a.746.746,0,0,0,0,1.055l4.851,4.851a.746.746,0,0,0,1.055,0Z",
    transform: "translate(-20415.563 -15577.563)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToast);
export default __webpack_public_path__ + "static/media/success_toast.2a1c4d65f2d6652590c919a6de041e74.svg";
export { ForwardRef as ReactComponent };